// Referral attribution: any page opened with ?ref=CODE remembers the code (see
// plugins/referral-capture.client.ts) so a visitor who browses a challenge page first and
// signs up later is still attributed. The signup page sends it as `referral_code`; the
// backend ignores unknown codes, so nothing here needs to validate beyond shape.

const KEY = 'sm_referral'
const TTL_MS = 30 * 24 * 60 * 60 * 1000

const normalise = (value: unknown): string | null => {
  if (typeof value !== 'string') return null
  const code = value.trim().toUpperCase()
  return /^[A-Z0-9]{4,16}$/.test(code) ? code : null
}

// Latest link wins: the person whose link was clicked most recently gets the referral.
export const saveReferralCode = (value: unknown) => {
  const code = normalise(value)
  if (!code) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, savedAt: Date.now() }))
  } catch { /* storage unavailable: no attribution */ }
}

export const getReferralCode = (): string | null => {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const { code, savedAt } = JSON.parse(raw)
    if (typeof savedAt !== 'number' || Date.now() - savedAt > TTL_MS) {
      localStorage.removeItem(KEY)
      return null
    }
    return normalise(code)
  } catch {
    return null
  }
}

export const clearReferralCode = () => {
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
}
